import { defineStore } from 'pinia'
import { ref } from 'vue'
import { appSocket } from '@/services/socket'

export const useTVConnectionStore = defineStore('tvConnection', () => {
  const status = ref<'idle'|'pending'|'offline'|'connected'>('idle')
  let room = '', pendingCode = ''
  function sendPair() { if (room && pendingCode) status.value = appSocket.pairTV(room, pendingCode) ? 'pending' : 'offline' }
  function paired() { if (!room || !pendingCode) return; pendingCode = ''; status.value = 'connected' }
  function disconnected() { status.value = pendingCode ? 'offline' : 'idle' }
  function context(userId: string) {
    const next = userId ? `coachsighttv-${userId}` : ''
    if (next === room) return
    stop()
    room = next
    if (!room) return
    appSocket.joinRoom(room)
    appSocket.on('PairComplete', paired)
    appSocket.on('connect', sendPair)
    appSocket.on('disconnect', disconnected)
  }
  function pair(code: string) { if (!room) return; pendingCode = code; sendPair() }
  function unpair() { if (room) appSocket.announce(room, 'DISCONNECT-TV', {}); pendingCode = ''; status.value = 'idle' }
  function stop() {
    if (room) appSocket.leaveRoom(room)
    appSocket.off('PairComplete', paired)
    appSocket.off('connect', sendPair)
    appSocket.off('disconnect', disconnected)
    room = ''; pendingCode = ''; status.value = 'idle'
  }
  return { status, context, pair, unpair, stop }
})
